import type { PropsWithChildren } from 'react';

import { RouterProvider } from 'react-aria-components';
import { useHref, useNavigate } from 'react-router-dom';
import { type NavigateOptions } from 'react-router-dom';

declare module 'react-aria-components' {
    interface RouterConfig {
        routerOptions: NavigateOptions;
    }
}

const ReactAriaRouterProvider = (props: PropsWithChildren) => {
    const navigate = useNavigate();

    return (
        <RouterProvider navigate={navigate} useHref={useHref}>
            {props.children}
        </RouterProvider>
    );
};

export default ReactAriaRouterProvider;
